<template>
  <div class="intro-animation app-size">
    <img
      src="../assets/img/ninja_corner/corner_down.gif"
      v-if="ninjaStatus === 'down'"
      alt=""
    />
    <img
      src="../assets/img/ninja_corner/corner_up.gif"
      @load="startAnimation()"
      v-if="ninjaStatus === 'up'"
      alt=""
    />
    <img
      src="../assets/img/ninja_corner/corner_talk.gif"
      v-if="ninjaStatus === 'talk'"
      alt=""
    />
    <audio ref="introSounds" @ended="endAnimation">
      <source :src="getIntroSound()" type="audio/mpeg" />
    </audio>
  </div>
</template>

<script>
export default {
  name: 'IntroAnimation',
  props: {
    isPicsIntro: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ninjaStatus: null
    };
  },
  mounted() {
    // if (this.$route.params.level != 'one') {
    this.startAnimation();
    // }
  },
  methods: {
    getIntroSound() {
      try {
        let sound = this.$route.params.level;
        // console.log(sound);

        if (
          this.$route.params.level === 'three' ||
          this.$route.params.level === 'four'
        ) {
          sound = 'four';
        }
        // console.log(`two_${this.$route.params.beltColor}`);
        if (sound === 'two') {
          sound = `two_${this.$route.params.beltColor}`;
          // console.log(sound);
        }
        if (this.isPicsIntro) {
          sound = 'choose_pic';
        }
        return require(`../assets/sound/ingame-sounds/${sound}.mp3`);
      } catch (e) {
        console.warn('could not load sound');
      }
    },
    startAnimation() {
      this.ninjaStatus = 'up';
      setTimeout(() => {
        this.ninjaStatus = 'talk';
        this.$refs.introSounds.play();
      }, 500);
    },
    endAnimation() {
      this.ninjaStatus = 'down';
      setTimeout(() => {
        this.$emit('endSound', true);
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
img {
  position: absolute;
}
</style>
